export default {"src":"/_next/static/media/sme.3561de41.svg","height":75,"width":76};